import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/usage.query.gql"
import type {
  UsageProfilesQuery,
  UsageProfilesQueryVariables,
} from "@/v2-backoffice-client/usage/__types__/usage.query"

type Options = QueryHookOptions<UsageProfilesQuery, UsageProfilesQueryVariables>

export function useUsageProfilesQuery(options?: Options) {
  return useQuery<UsageProfilesQuery, UsageProfilesQueryVariables>(
    query,
    options,
  )
}
